module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": "fade",
      "mode": "out-in"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.myActive && _vm.show),
      expression: "myActive && show"
    }],
    staticClass: "tab-pane",
    class: {
      active: _vm.myActive
    },
    attrs: {
      "role": "tabpanel"
    }
  }, [_vm._t("default")], 2)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-942cbac8"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/tab/tabpage.vue
// module id = 557
// module chunks = 23